var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid grid--gutter-30"},_vm._l((_vm.contacts),function(ref){
var title = ref.title;
var linkTitle = ref.linkTitle;
var linkValue = ref.linkValue;
var targetBlank = ref.targetBlank;
var icon = ref.icon;
return _c('div',{key:linkValue,staticClass:"col sc-992-4"},[_c('section-contacts-card',{attrs:{"label":title,"value":linkTitle,"icon":icon,"link":linkValue,"target":targetBlank ? '_blank' : null}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }